(() => {
  const scripts = new Map();
  const load = src => {
    if (!scripts.has(src)) scripts.set(src, new Promise((resolve, reject) => {
      const s = document.createElement('script'); s.src = src; s.async = true;
      const fail = () => { clearTimeout(timer); scripts.delete(src); s.remove(); reject(new Error('Unavailable')); };
      const timer = setTimeout(fail, 15000);
      s.onload = () => { clearTimeout(timer); resolve(); }; s.onerror = fail;
      document.head.appendChild(s);
    }));
    return scripts.get(src);
  };
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog'), status = root.querySelector('[data-status]');
    const start = root.querySelector('[data-start]'), holder = root.querySelector('[data-widget]');
    let token = '', challengeId, challengeTimer, preparing = false, generation = 0;
    const unavailable = () => { status.textContent = status.dataset.unavailable; };
    const close = () => {
      generation++; preparing = false; holder.replaceChildren(); token = ''; start.disabled = true; clearTimeout(challengeTimer);
      if (challengeId !== undefined && window.turnstile) { window.turnstile.remove(challengeId); challengeId = undefined; }
      dialog.close(); root.querySelector('[data-open]').focus();
    };
    root.querySelector('[data-close]').addEventListener('click', close);
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    root.querySelector('[data-open]').addEventListener('click', async () => {
      const current = ++generation; dialog.showModal(); status.textContent = '';
      if (root.dataset.enabled !== 'true' || !root.dataset.endpoint || !root.dataset.sitekey) return unavailable();
      try {
        const endpoint = new URL(root.dataset.endpoint);
        if (endpoint.origin !== 'https://vrqieikgcbzpudefeudc.supabase.co' || endpoint.pathname !== '/functions/v1/pt-voice-session' || endpoint.search) return unavailable();
        await load('https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit');
        if (!dialog.open || current !== generation) return;
        challengeTimer = setTimeout(unavailable, 20000);
        challengeId = window.turnstile.render(root.querySelector('[data-challenge]'), {
          sitekey: root.dataset.sitekey, action: 'pt_assistant', theme: 'light', size: window.matchMedia('(max-width: 379px)').matches ? 'compact' : 'flexible',
          callback: value => { clearTimeout(challengeTimer); status.textContent = ''; token = value; start.disabled = false; },
          'expired-callback': () => { token = ''; start.disabled = true; },
          'error-callback': () => { clearTimeout(challengeTimer); token = ''; start.disabled = true; unavailable(); }
        });
      } catch { unavailable(); }
    });
    start.addEventListener('click', async () => {
      if (preparing || !token) return;
      const current = generation; preparing = true; start.disabled = true; status.textContent = status.dataset.loading;
      try {
        const response = await fetch(root.dataset.endpoint, { method: 'POST', credentials: 'omit', headers: {'Content-Type':'application/json'}, body: JSON.stringify({challenge_token:token}), signal: AbortSignal.timeout(15000) });
        if (current !== generation) return;
        token = '';
        const result = await response.json();
        if (!response.ok) {
          const messages = { SESSION_LIMIT: status.dataset.limit, VERIFICATION_FAILED: status.dataset.verification, ASSISTANT_UNAVAILABLE: status.dataset.service, INVALID_PROVIDER_RESPONSE: status.dataset.service };
          status.textContent = messages[result.error] || status.dataset.unavailable;
          return;
        }
        const signed = new URL(result.signed_url);
        if (signed.protocol !== 'wss:' || signed.hostname !== 'api.elevenlabs.io' || signed.searchParams.get('agent_id') !== 'agent_4001m2v2xb40eekajvhwgn20w1av') throw new Error('Invalid session');
        await load('https://unpkg.com/@elevenlabs/convai-widget-embed@0.18.2');
        if (!dialog.open || current !== generation) return;
        const widget = document.createElement('elevenlabs-convai');
        widget.setAttribute('signed-url', signed.href);
        widget.setAttribute('variant', 'full');
        widget.setAttribute('default-expanded', 'true');
        widget.setAttribute('show-conversation-id', 'false');
        widget.setAttribute('markdown-link-allowed-hosts', 'patchtripper.com,quote.patchtripper.com');
        holder.replaceChildren(widget); status.textContent = '';
        clearTimeout(challengeTimer);
        if (challengeId !== undefined && window.turnstile) { window.turnstile.remove(challengeId); challengeId = undefined; }
        dialog.close(); root.querySelector('[data-open]').hidden = true;
      } catch { unavailable(); }
      finally {
        if (current === generation) preparing = false;
      }
    });
  }
  const init = () => document.querySelectorAll('[data-pt-assistant]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
